import { useReducer, useEffect, useRef } from "react";
import { useTab } from "../hooks/useTab.js";
import { appReducer, makeInitialState } from "../hooks/useAppReducer.js";
import { odpReducer, makeInitialOdpState } from "../hooks/useOdpReducer.js";
import { teardownResults, revokeUrl } from "../state.js";
import { Header } from "./Header.js";
import { TabBar } from "./TabBar.js";
import { OverlayTab } from "./overlay/OverlayTab.js";
import { OdpCardTab } from "./odp/OdpCardTab.js";

export function App() {
  const [tab, setTab] = useTab();
  const [appState, appDispatch] = useReducer(appReducer, undefined, makeInitialState);
  const [odpState, odpDispatch] = useReducer(odpReducer, undefined, makeInitialOdpState);

  const appStateRef = useRef(appState);
  appStateRef.current = appState;

  useEffect(() => {
    const onUnload = () => {
      const s = appStateRef.current;
      teardownResults(s.results);
      for (const inp of s.inputs) revokeUrl(inp.thumbUrl);
    };
    window.addEventListener("pagehide", onUnload);
    return () => window.removeEventListener("pagehide", onUnload);
  }, []);

  return (
    <>
      <Header />
      <TabBar activeTab={tab} onTabChange={setTab} />
      <div>
        {tab === "overlay" ? (
          <OverlayTab state={appState} dispatch={appDispatch} />
        ) : (
          <OdpCardTab state={odpState} dispatch={odpDispatch} />
        )}
      </div>
    </>
  );
}
